import axios from "axios";
import { auth } from "../utils/firebase"; // adjust path if needed

const thanq = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

// 🔑 Request interceptor to add bearer token
thanq.interceptors.request.use(
    async (config) => {
        const user = auth.currentUser;
        if (user) {
            try {
                // fetch fresh Firebase ID token
                const token = await user.getIdToken();
                config.headers.Authorization = `Bearer ${token}`;
            } catch (error) {
                console.error("Failed to get ID token:", error);
                // If we can't get token, user might not be authenticated
                // Let the request proceed without token and handle 401 in response interceptor
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// 🚨 Response interceptor to handle 401 errors
thanq.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
            console.warn("401 Unauthorized - signing out user");

            try {
                // Sign out the user from Firebase
                await auth.signOut();
            } catch (signOutError) {
                console.error("Error signing out:", signOutError);
            }
        }

        return Promise.reject(error);
    }
);

export default thanq;
